import { __extends } from "tslib";
import { Event } from './Event';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: GameInputEvent
var GameInputEvent = /** @class */ (function (_super) {
    __extends(GameInputEvent, _super);
    function GameInputEvent(type, bubbles, cancelable, device) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (device === void 0) { device = null; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        // TODO: coerce
        _this.device = device;
        return _this;
    }
    GameInputEvent.classInitializer = null;
    GameInputEvent.classSymbols = null;
    GameInputEvent.instanceSymbols = null;
    // JS -> AS Bindings
    GameInputEvent.DEVICE_ADDED = 'deviceAdded';
    GameInputEvent.DEVICE_REMOVED = 'deviceRemoved';
    return GameInputEvent;
}(Event));
export { GameInputEvent };
